import React from 'react';
import { Button, Paragraph } from 'elements';
import { ArrowRight } from 'core/icons';
import {
  ActionAlignment,
  StyledContent,
  StyledHeading,
  StyledSubtitle,
} from './styled';


const Content = ({
  title,
  subtitle,
  description,
  actionLabel,
  onClick,
  compact,
  type
}) => {
  const getHeadingLevel = ({compact, type}) => {
    switch (type) {
      case 'cover':
      case 'icon':
      case 'video':
        return compact ? 6 : 3;
      case 'link':
        return compact ? 6 : 5;
      default:
        return compact ? 5 : 4;
    }
  }

  const appearanceProps = {
    compact,
    type
  };

  // TODO: Ja nepieciešams, virsraksta
  // un apraksta saīsināšana (truncate).

  const headingLevel = getHeadingLevel(appearanceProps);
  const contentTitle = (
    <StyledHeading level={headingLevel}>
      {title}
    </StyledHeading>
  );

  const descriptionSize = compact ? 'small' : 'default';

  const contentSubtitle = subtitle && (
    <StyledSubtitle size={descriptionSize}>
      {subtitle}
    </StyledSubtitle>
  );

  const contentDescription = (
    <Paragraph size={descriptionSize} maxLines='2' >
      {description}
    </Paragraph>
  );

  const hasActionLabel = (actionLabel && actionLabel.length > 0) || false;
  const actionButton = /* default */ !type && (
    <ActionAlignment
      {...appearanceProps}
      hasLabel={hasActionLabel}
    >
      <Button
        tabIndex='-1'
        icon={ArrowRight}
        iconSize={hasActionLabel ? 'small' : 'large'}
        label={actionLabel}
        type='text'
        onClick={onClick}
      />
    </ActionAlignment>
  );

  return (
    <StyledContent {...appearanceProps}>
      <header>
        {contentTitle}
        {contentSubtitle}
      </header>

      {contentDescription}
      {actionButton}
    </StyledContent>
  );
};

export default Content;



// WEBPACK FOOTER //
// ./src/elements/Card/components/Content/Content.jsx